<template>
  <div class="radish-right" v-if="isShow">
    <div class="radish-head">
      <div class="radish-title">Excel导入</div>
      <div class="radish-btns"><el-button size="mini" icon="el-icon-close" circle @click="close"></el-button></div>
    </div>
    <div v-loading="loading">
      <div class="radish-body" v-if="step === 1">
        <div class="radish-box">
          <div class="radish-box-content">
            <div>说明：</div>
            <ul>
              <li>
                此处只支持标准SL的上传，原始list（公司通讯录）请到右上角
                <el-button type="primary" size="mini" icon="el-icon-upload" plain> LIST快速上传 </el-button>
              </li>
              <li>支持格式：xls、xlsx，文件大小不能超过5M；</li>
              <li>只支持导入Excel的第一个sheet中的内容；</li>
              <li>不支持含有合并单元格的Excel；</li>
              <li>姓名不可为空；</li>
            </ul>
          </div>
        </div>
        <div class="radish-box">
          <UploadInner
            ref="UploadInner"
            type="searchlist"
            label="searchlist"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-exceed="uploadExceed"
            :beforeUpload="beforeUpload"
            :limit="1"
          ></UploadInner>
        </div>
      </div>
      <div class="radish-body" v-if="step === 2">
        <div class="radish-box radish-up-excel">
          <div class="radish-box-content">
            <el-alert
              type="warning"
              title="表头未对应："
              description="本次上传文件内的表头中，以下未和系统标准对应，如果不进行选择，会默认放弃此字段，造成数据丢失。请在‘系统对应表头’这一列，下拉选择正确的表头名称。"
              :closable="false"
            ></el-alert>
            <el-row>
              <el-col :span="8"><b>上传Excel表头</b></el-col>
              <el-col :span="8"><b>系统对应表头</b></el-col>
              <el-col :span="8"><b>本列对应内容</b></el-col>
            </el-row>
            <el-row v-for="(uf, k) in unknownFields" :key="k">
              <el-col :span="8">{{ uf.field }}</el-col>
              <el-col :span="8">
                <el-select v-model="uf.rightField" filterable placeholder="请选择" size="mini">
                  <el-option label="放弃" :value="undefined"> </el-option>
                  <el-option v-for="item in remainingFields" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">{{ uf.value }}</el-col>
            </el-row>
            <el-row><el-button type="primary" size="mini" @click="matchHead">确定</el-button></el-row>
          </div>
        </div>
        <div class="radish-box" style="line-height:1.5">
          <b style="font-size:13px">系统标准表头字段及说明：</b><br />
          长期意向（Y：人选近期看机会；F：意向待跟进；N：不看任何外部机会）、<br />
          职级（1.高管；2.部门总；3.部门副总/总助/团队长；4.部门核心骨干；5新人三年以下）、<br />
          曾任职公司（多个标签以英文分号做区分）、<br />
          个性标签（多个标签以英文分号区分）、<br />
          平台（A、B、C；A为最好，C为最差）、<br />
          业绩（aaa;aa;a;b;c；aaa为最好，c为最差）、<br />
          性别（男；女）、出生年月（1990.01）、<br />
          本科院校（学校名称）、硕士院校（学校名称）、<br />
          地域（人选所在地域，多个地点以英文分号区分）、<br />
          姓名、公司、部门、组别、目前职位、<br />
          手机、职能模块、细分职能、擅长方向、<br />
          座机、邮箱、行业、简介、婚育、籍贯、学历
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import tmpRes from './tmpRes'
import UploadInner from '../components/upload-inner'
export default {
  components: { UploadInner },
  data: function() {
    return {
      isShow: false,
      loading: false,
      uploadFile: {},
      step: 1,
      unknownFields: [],
      remainingFields: [],
      sheetId: '',
      // step: 2,
      // unknownFields: tmpRes.data.unknownFields,
      // remainingFields: tmpRes.data.remainingFields,
      // sheetId: 'HyIOzowDE',
    }
  },
  methods: {
    uploadSuccess: async function(response, file, fileList) {
      if (response.length > 0 && response[0]._id) {
        this.loading = true
        this.uploadFile = response[0]
        const res = await app.service('radish').excelHeadCheck({
          file: { _id: this.uploadFile._id, md5: this.uploadFile.md5, originalname: this.uploadFile.originalname },
        })
        if (res.status === 'success') {
          this.sheetId = res.data.sheetId
          if (res.data.unknownFields.length > 0) {
            this.unknownFields = res.data.unknownFields
            this.remainingFields = res.data.remainingFields
            this.step = 2
            this.preview(this.uploadFile)
          } else {
            this.matchHead()
          }
        } else {
          this.$alert(`文件${file.name}解析失败，原因：${res.msg}`, { showClose: false })
        }
        this.loading = false
      } else {
        console.error('upload no response')
      }
      this.$refs.UploadInner.clean()
    },
    beforeUpload: function(file) {
      const checkSupport = new RegExp('(.xls|.xlsx)$')
      const isTypeRight = checkSupport.test(file.name)
      const isLt5M = file.size / 1024 / 1024 < 5
      let msg = ''
      if (!isTypeRight) {
        msg = msg + '上传文件类型只能是xls或xlsx! '
      }
      if (!isLt5M) {
        msg = msg + '上传文件大小不能超过5MB!'
      }
      if (!isTypeRight || !isLt5M) {
        this.$alert(msg, { showClose: false })
      }
      return isTypeRight && isLt5M
    },
    uploadError: function(err, file, fileList) {
      this.$alert(`文件${file.name}上传失败`, { showClose: false })
      this.$refs.UploadInner.clean()
    },
    uploadExceed: function(files, fileList) {
      this.$alert(`文件数量超出限制，限制最多选择1个文件，本次选择了${files.length}个文件`, { showClose: false })
    },
    matchHead: async function() {
      this.loading = true
      const res = await app.service('radish').excelCheck({ unknownFields: this.unknownFields, sheetId: this.sheetId })
      // console.log(res)
      if (res.status === 'success') {
        if (res.data.length === 0) {
          return this.$alert('文件未解析出数据', { showClose: false })
        }
        app.root.$refs.ExcelCorrection.show({ records: res.data, sheetId: this.sheetId })
        this.$nextTick(() => {
          this.reset()
        })
      } else {
        this.$alert(`表头对应失败，原因：${res.msg}`, { showClose: false })
      }
      this.loading = false
    },
    preview: async function(file) {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    open: function() {
      this.reset()
      this.isShow = true
    },
    close: function() {
      this.isShow = false
    },
    reset: function() {
      this.uploadFile = {}
      this.step = 1
      this.unknownFields = []
      this.remainingFields = []
      this.sheetId = ''
    },
  },
}
</script>
<style>
.radish-up-excel .el-row {
  line-height: 36px;
  border-bottom: 1px solid #ccc;
}
</style>
